export class Tester {

    nome: string;
    cognome: string;
    genere: string;
    anni: any;
    test: any;
    logged: boolean;
    test_id: string;
    token_partenza: number;
}


// WEBPACK FOOTER //
// ./src/app/auth/_models/tester.ts